import React from "react";
import "./gallery.css";
import img1 from "../../assets/booknow.jpg";
import img2 from "../../assets/img2.jpg";
import img3 from "../../assets/img3.jpg";
import img4 from "../../assets/dishes.jpg";
import img5 from "../../assets/img5.jpg";
import img6 from "../../assets/freewifi.jpg";

export const Gallery = () => {
  const cardsContent = [
    { id: 1, image: img1, title: "Luxurious Rooms" },
    { id: 2, image: img2, title: "Swimming Pool" },
    { id: 3, image: img3, title: "Restaurant Area" },
    { id: 4, image: img4, title: "Delicious Dish" },
    { id: 5, image: img5, title: "Event Hall" },
    { id: 6, image: img6, title: "High-speed Wi-Fi access" },
  ];

  return (
    <div className="gallery-page">
      <section className="gallery-section">
        <div className="section-top">
          <h1>Our Gallery</h1>
          <p>Explore our hotel and restaurant through stunning visuals.</p>
        </div>

        <div className="image-grid">
          {cardsContent.map((card) => (
            <div className="card" key={card.id}>
              <img src={card.image} alt={card.title} />
              <div className="card-overlay">
                <h3>{card.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
